import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.element.addEventListener('paginatedArticles:page:updated', this.#focusOnCurrentPage);
    }

    disconnect() {
        this.element.removeEventListener('paginatedArticles:page:updated', this.#focusOnCurrentPage);
    }

    #focusOnCurrentPage = () => {
        this.element.querySelector('[aria-current="page"]')?.focus();
    };

    sendPageViewEvent({ currentTarget }) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'etuEventSearchPageView',
            pageNumber: +currentTarget.getAttribute('data-value') || 1,
            pageType: 'Search',
        });
    }
}
